module.exports = __webpack_public_path__ + "img/cvs-downArrow.098185b9.svg";